export default __webpack_public_path__ + "static/media/yahoo.65de449b.svg";